import React from 'react';
import { Chip } from '@mui/material';
import { AddShoppingCart as AddShoppingCartIcon } from '@mui/icons-material';
import { HiDocumentText, HiTrash, HiBookmark } from 'react-icons/hi2';
import './SavedPaperCard.css';

// Card component for displaying saved papers
const SavedPaperCard = ({ paper, onRemove, onAddToCart, userType }) => {
    const handleAddToCart = () => {
        if (onAddToCart) {
            onAddToCart();
        }
    };

    return (
        <div className="saved-paper-card">
            <div className="saved-paper-content">
                <div className="saved-paper-icon-wrapper">
                    <HiDocumentText className="saved-paper-icon" />
                </div>

                {/* Title + credits count stacked */}
                <div className="saved-paper-details">
                    <h4 className="saved-paper-title">{paper.title}</h4>
                    {userType === "parent" && paper.user_code && (
                        <p className="saved-paper-subtitle">For Student: {paper.user_code}</p>
                    )}
                    {/* <p className="saved-paper-subtitle">{paper.credits} Credit(s)</p> */}
                </div>

                {/* Price chip */}
                <Chip
                    label={`${paper.price.toFixed(2)} ${paper.currencySymbol}`}
                    size="small"
                    className="saved-paper-price-chip"
                />

                {/* Add to Cart and Remove grouped */}
                <div className="saved-paper-actions">
                    <button
                      className="ph-paper-btn ph-paper-btn-cart"
                      onClick={handleAddToCart}
                    >
                      <>
                        <AddShoppingCartIcon />
                        Add to Cart
                      </>
                    </button>
                    <button
                        onClick={onRemove}
                        className="saved-paper-remove-btn"
                        aria-label="Remove item"
                    >
                        <HiTrash />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SavedPaperCard;